import { render, staticRenderFns } from "./albumTempDetail.vue?vue&type=template&id=8de80c2a&scoped=true"
import script from "./albumTempDetail.vue?vue&type=script&lang=js"
export * from "./albumTempDetail.vue?vue&type=script&lang=js"
import style0 from "./albumTempDetail.vue?vue&type=style&index=0&id=8de80c2a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de80c2a",
  null
  
)

export default component.exports